import type { ReactNode } from 'react';
import { clsx } from '../../../ds/clsx';
import styles from './WizardLayout.module.css';

export interface WizardLayoutProps {
  /** The `WizardHeader` (absent on pages without stepper, e.g. Admin 02). */
  header?: ReactNode | undefined;
  /** Width of the content column: 940 (Marke, Rechtstexte, Domain, Telefonie), 860 (Firmendaten), 1040 (Team). */
  width: number;
  /** Row gap of the column: 24 (default) or 22 (Firmendaten). */
  gap?: 22 | 24 | undefined;
  children: ReactNode;
}

/** A wizard page at ≥ 768 px: stepper header and the centred column with the frame's padding 44/40. */
export function WizardLayout({ header, width, gap = 24, children }: WizardLayoutProps) {
  return (
    <div className={styles.page}>
      {header}
      <main className={styles.body}>
        <div className={clsx(styles.column, gap === 22 && styles.gap22)} style={{ width, maxWidth: '100%' }}>
          {children}
        </div>
      </main>
    </div>
  );
}

export interface WizardIntroProps {
  eyebrow: string;
  title: string;
  text?: ReactNode | undefined;
  /** Width of the lead text: 600 (default) or the frame's 640. */
  textWidth?: number | undefined;
}

/** „Schritt 1 von 6" · display title 30 px · 14 px lead text (max. 600 px). */
export function WizardIntro({ eyebrow, title, text, textWidth }: WizardIntroProps) {
  return (
    <div className={styles.intro}>
      <span className={styles.eyebrow}>{eyebrow}</span>
      <h1 className={styles.title}>{title}</h1>
      {text ? (
        <p className={styles.text} style={textWidth ? { maxWidth: textWidth } : undefined}>
          {text}
        </p>
      ) : null}
    </div>
  );
}
